import { Pipe, PipeTransform } from '@angular/core';
import { formatPhone, phoneParts } from '../utils/phone.util';

/**
 * Renders a stored phone value in canonical form.
 *
 * Existing rows are not being backfilled, so every display site has to format
 * on read: the column holds a mix of "(916) 481-0268", "9164810268" and older
 * junk, and only this pipe makes them look alike.
 */
@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {
  transform(value: string): string {
    return formatPhone(value);
  }
}

/**
 * The individual numbers behind a value, for building one tel: link per
 * number. A tel: URI containing a comma separated list is not dialable.
 */
@Pipe({ name: 'phoneList' })
export class PhoneListPipe implements PipeTransform {
  transform(value: string): string[] {
    return phoneParts(value);
  }
}
